/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import Popup from 'reactjs-popup';
import { useSelect, useDispatch } from '@wordpress/data';

const divsToUpdate = document.querySelectorAll(".wie-levert-wat-categories")

divsToUpdate.forEach(div => {
	const data = JSON.parse(div.querySelector("pre").innerText)
	const root = ReactDOM.createRoot(div)
	root.render(<WieLevertWatCategories {...data} />)
	div.classList.remove("wie-levert-wat-component")
});

function WieLevertWatCategories(props) {

	const [selectedValue, setSelectedValue] = useState(null);
	const [isLoaded, setIsLoaded] = useState(false);

	const actions = useDispatch('lef-digitaal/wie-levert-wat');

	const categoriesData = useSelect( (select) => {
		const store = select('lef-digitaal/wie-levert-wat');
		setIsLoaded(true);
		return store && store.getCategories();
	}, []);

	const onOptionChange = (value) => {
		setSelectedValue(value);
		if (actions.toggleCategoryFilter){
			actions.toggleCategoryFilter(value, true);
		}
	}

	useEffect(() => {
		let querystring = new URLSearchParams(window.location.search).get('cat');
		var result = findCategory(categoriesData, querystring);
		if (result) {
			onOptionChange(result);
		}
		
	}, [categoriesData]);

	function findCategory(categories, slug) {
		for(let category of categories){
			if (category.category_slug === slug) {
				return category;
			}

			if (category.children && category.children.length > 0){
				let childCategory = findCategory(category.children, slug);
				if (childCategory) {
					return childCategory;
				}
			}
		}
		// Couldn't find anything
		return null;
	}

	// If has childeren -> render as a title as a label for a checkbox. If checkbox checked, collapse the underlying menu.

	if (!isLoaded) {
	  return <div>Laden...</div>
	} else {
	  return (
		<div className="wie-levert-wat-categories">
		  	<div class="categories">
			  <div class="checkbox-wrapper-13 show-all">
					<input id="-1" className="form-check-input"
						type="radio"
						name="category"
						checked = {selectedValue == null}
						value={null}
						onChange = { (e) => onOptionChange(null) }/>
					<label for="-1">
						Toon alle rubrieken
					</label>
				</div>
				{categoriesData.sort((a,b) => b.children.length - a.children.length).map((category, index) => ( 
					category.children.length > 0 ? (
						<div className="dropdown-wrapper">
							<input type="checkbox" 
								id={index} 
								className="menu-control"/>
							<div class="dropdown-control checkbox-wrapper-13">
								<label for={index}>
									<input id={category.category_id} className="form-check-input"
										type="radio"
										name="category"
										checked={selectedValue == category}
										value={{category}}
										onChange = { (e) => onOptionChange(category) }/>
										<label for={category.category_id}>{category.category_name}</label>
										<i class="fa-solid fa-chevron-down"></i>
								</label>
							</div>
							<div className="dropdown">
								{category.children.map((cat, index) => 
								<div class="checkbox-wrapper-13">
									<input id={cat.category_id} className="form-check-input"
										type="radio"
										name="category"
										checked={selectedValue == cat}
										value={{cat}}
										onChange = { (e) => onOptionChange(cat) }/>
									<label for={cat.category_id}>
										{cat.category_name}
									</label>
								</div>
								)}
							</div>
						</div>
					) : (
						<div class="checkbox-wrapper-13">
							<input id={category.category_id} className="form-check-input"
								type="radio"
								name="category"
								checked={selectedValue == category}
								value={{category}}
								onChange = { (e) => onOptionChange(category) }/>
							<label for={category.category_id}>
								{category.category_name}
							</label>
						</div>
					)
				))}
		  	</div>
		  	<div className="categories-mobile">
				<Popup trigger={<a className="button-primary"><i class="fa-solid fa-filter"></i></a>} modal nested>
					{close => (
						<div className="category-modal">
							<div class="categories">
							<div class="checkbox-wrapper-13 show-all">
									<input id="-2" className="form-check-input"
										type="radio"
										name="category"
										checked = {selectedValue == null}
										value={null}
										onChange = { (e) => onOptionChange(null) }/>
									<label for="-2">
										Toon alle rubrieken
									</label>
								</div>
								{categoriesData.sort((a,b) => b.children.length - a.children.length).map((category, index) => ( 
									category.children.length > 0 ? (
										<div className="dropdown-wrapper">
											<input type="checkbox" 
												id={"mobile-"+index} 
												className="menu-control"/>
											<div class="dropdown-control checkbox-wrapper-13">
												<label for={"mobile-"+index}>
													<input id={"mobile-"+category.category_id} className="form-check-input"
														type="radio"
														name="category"
														checked={selectedValue == category}
														value={{category}}
														onChange = { (e) => onOptionChange(category) }/>
														<label for={"mobile-"+category.category_id}>{category.category_name}</label>
														<i class="fa-solid fa-chevron-down"></i>
												</label>
											</div>
											<div className="dropdown">
												{category.children.map((cat, index) => 
												<div class="checkbox-wrapper-13">
													<input id={"mobile-"+cat.category_id} className="form-check-input"
														type="radio"
														name="category"
														checked={selectedValue == cat}
														value={{cat}}
														onChange = { (e) => onOptionChange(cat) }/>
													<label for={"mobile-"+cat.category_id}>
														{cat.category_name}
													</label>
												</div>
												)}
											</div>
										</div>
									) : (
										<div class="checkbox-wrapper-13">
											<input id={"mobile-"+category.category_id} className="form-check-input"
												type="radio"
												name="category"
												checked={selectedValue == category}
												value={{category}}
												onChange = { (e) => onOptionChange(category) }/>
											<label for={"mobile-"+category.category_id}>
												{category.category_name}
											</label>
										</div>
									)
								))}
							</div>
							<div className="actions">
								<a className="button-primary"
									onClick={() => {
										close();
									}}>
									<i class="fa-solid fa-check"></i>
								</a>
							</div>
						</div>
					)}
				</Popup>
			</div>
		</div>
	  )
	}
  }
  